// Same rules as DeliveryApp/src/utils/helper/deliveredRxDisplay.js.
// Completed prescriptions are shown as read-only history. They must never be
// selected, validated, handed over or submitted as a new delivery.

// Do not infer this from the parent delivery_status: a multi-dose prescription
// can have a delivered parent while later child doses are still pending.
// The backend's parent + child roll-up is the authoritative signal. The Driver
// App gets it as is_fully_delivered; the instore patient-detail route exposes
// the same roll-up as rx_access.can_deliver === false.
export const isRxFullyDelivered = (rx) =>
	rx?.is_fully_delivered === true || rx?.rx_access?.can_deliver === false

const isDeliveredStatus = (item) => String(item?.delivery_status || '').toLowerCase() === 'delivered'

// Payload-side check. Besides the backend roll-up, also treats a delivered
// single-dose Rx (no dose list) and a multi-dose Rx whose doses are all
// delivered as complete. A delivered parent with a pending dose stays
// deliverable.
export const isRxAlreadyDelivered = (rx) => {
	if (isRxFullyDelivered(rx)) return true

	const doses = Array.isArray(rx?.investigate_dilaudid_delivery_all) && rx.investigate_dilaudid_delivery_all.length > 0
		? rx.investigate_dilaudid_delivery_all
		: (Array.isArray(rx?.investigate_dilaudid_delivery_history) ? rx.investigate_dilaudid_delivery_history : [])

	if (doses.length === 0) return isDeliveredStatus(rx)
	return doses.every(isDeliveredStatus)
}

// Drop ids of already delivered Rxs from a confirm-delivery selection.
// Ids not found in rxData are kept (e.g. flexi ids from another list).
export const withoutDeliveredRxIds = (ids, rxData) => {
	const list = Array.isArray(ids) ? ids : []
	const rowsById = new Map((Array.isArray(rxData) ? rxData : []).map((rx) => [String(rx?.id), rx]))
	return list.filter((id) => {
		const rx = rowsById.get(String(id))
		return !rx || !isRxAlreadyDelivered(rx)
	})
}

// The pending list only returns Rxs that still need delivery. Pull today's
// fully delivered Rxs from the patient-detail payload, skipping any id the
// pending list already shows.
export const getDeliveredHistoryRx = (detailRxData, pendingRxData) => {
	const pendingIds = new Set(
		(Array.isArray(pendingRxData) ? pendingRxData : []).map((rx) => String(rx?.id))
	)

	return (Array.isArray(detailRxData) ? detailRxData : [])
		.filter((rx) => rx?.id != null && !pendingIds.has(String(rx.id)) && isRxFullyDelivered(rx))
}
